/* CampusNotes storefront behaviour: live search, quick add, bundle add, shelves, filters. No dependencies. */
(function () {
  if (window.__cnInit) return; window.__cnInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BUNDLE_QTY = 3; /* tiers must match Shopify automatic discounts */
  function tierPct(n) { return n >= 4 ? 35 : n >= 3 ? 25 : 0; }
  var money = function (v) { var n = typeof v === 'string' ? parseFloat(v) : v / 100; return '$' + n.toFixed(2); };
  /* Shopify rounds each line's discount down to the cent, so price bundles per line to match checkout */
  function bundleTotal(prices) { var sorted=prices.slice().sort(function(a,b){return b-a}),total=0;while(sorted.length>=4)total+=Math.min(7999,sorted.splice(0,4).reduce(function(a,b){return a+b},0));if(sorted.length===3)total+=Math.min(6499,sorted.splice(0,3).reduce(function(a,b){return a+b},0));return total+sorted.reduce(function(a,b){return a+b},0); }
  var DUR = function (name, fb) { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)); return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : (v || fb); };
  /* transitions.dev text states swap: old text exits up with blur, new text rises in */
  function swapText(el, next) {
    if (!el || el.textContent === next) return;
    var d = DUR('--text-swap-dur', 150);
    if (!d) { el.textContent = next; return; }
    clearTimeout(el._sw); el.classList.add('is-exit');
    el._sw = setTimeout(function () { el.textContent = next; el.classList.remove('is-exit'); el.classList.add('is-enter-start'); void el.offsetHeight; el.classList.remove('is-enter-start'); }, d);
  }
  /* transitions.dev number pop-in: digits re-enter with a blurred slide, last two staggered */
  function popDigits(group, str) {
    if (!group) return;
    if (group.textContent === str) return;
    group.classList.remove('is-animating'); group.replaceChildren();
    var ch = str.split('');
    ch.forEach(function (c, i) { var sp = document.createElement('span'); sp.className = 't-digit'; sp.textContent = c; if (i === ch.length - 2) sp.dataset.stagger = '1'; else if (i === ch.length - 1) sp.dataset.stagger = '2'; group.appendChild(sp); });
    void group.offsetHeight; group.classList.add('is-animating');
  }
  function popBadge() { setTimeout(function () { document.querySelectorAll('.cart-count-bubble').forEach(function (b) { b.classList.remove('is-popping'); void b.offsetWidth; b.classList.add('is-popping'); }); }, 30); }
  var esc = function (s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Cart: one request adds the item and returns the fresh drawer ---------- */
  var SECTIONS = 'cart-drawer,cart-icon-bubble,cn-drawer-extras';
  function drawer() { var d = document.querySelector('cart-drawer'); return d && typeof d.renderContents === 'function' ? d : null; }
  function onCartPage() { return location.pathname.replace(root, '/') === '/cart'; }
  function refreshBubble() {
    return fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var el = document.getElementById('cart-icon-bubble'); if (!el || !d['cart-icon-bubble']) return;
      var tmp = document.createElement('div'); tmp.innerHTML = d['cart-icon-bubble'];
      var inner = tmp.querySelector('.shopify-section'); el.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
    }).catch(function () {});
  }
  function addItems(items) {
    var body = { items: items };
    if(items.some(function(i){return String(i.id)==='50679293575424'}))body.items=items;
    if (drawer() && !onCartPage()) { body.sections = SECTIONS; body.sections_url = location.pathname; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return syncBundle(); }); });
  }
  var syncing, cartRemoving;
  function syncBundle() {
    if(syncing)return syncing;
    syncing=fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(cart){
      if(cart.currency!=='AUD')throw new Error('Semester bundle prices are available in AUD.');
      var ids=cart.items.filter(function(i){return i.product_type!=='Membership'&&!i.selling_plan_allocation}).map(function(i){return String(i.variant_id)});
      return fetch(root+'apps/cn/bundle-quote',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({variants:ids})}).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.error||'Could not confirm the bundle price.');return j})}).then(function(quote){
        var codes=(cart.discount_codes||[]).map(function(c){return c.code}).filter(function(c){return !/^CNB/i.test(c)});
        if(quote.code)codes.push(quote.code);
        if(cart.items.some(function(i){return String(i.variant_id)==='50679293575424'})&&codes.indexOf('VIPWELCOME9')<0)codes.push('VIPWELCOME9');
        var payload={discount:codes.join(','),sections:SECTIONS,sections_url:location.pathname};
        return fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)}).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error('Could not confirm the bundle price.');j._cnChanged=j.total_price!==cart.total_price||JSON.stringify((cart.discount_codes||[]).map(function(c){return c.code}).sort())!==JSON.stringify(codes.slice().sort());return j})});
      });
    }).finally(function(){syncing=null});return syncing;
  }
  // Wait for the actual removal response before requesting a new bundle quote.
  // A timer can race a slow cart/change request and reapply the previous quote.
  document.addEventListener('click',function(e){
    var remove=e.target.closest('cart-remove-button');if(!remove)return;
    var link=remove.querySelector('a[href]'),line=Number(remove.dataset.index);
    var id=link&&new URL(link.href,location.href).searchParams.get('id');
    if(!id&&!line)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(cartRemoving)return;
    busy(remove,true);
    var change=id?{id:id,quantity:0}:{line:line,quantity:0};
    cartRemoving=Promise.resolve(syncing).catch(function(){}).then(function(){
      return fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(change)});
    }).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||'Could not remove the note.');return j;});})
      .then(function(){return syncBundle();}).then(function(res){
        if(onCartPage()){location.reload();return;}
        var d=drawer();if(d&&res.sections){d.classList.toggle('is-empty',res.item_count===0);d.renderContents(res);placeExtras(res.sections['cn-drawer-extras']);}
        else location.assign(root+'cart');
      }).catch(function(err){busy(remove,false);alert(err.message+' Refresh your cart before trying again.');})
      .finally(function(){cartRemoving=null;});
  },true);
  document.addEventListener('click',function(e){var b=e.target.closest('[name="checkout"],a[href="/checkout"]');if(!b)return;e.preventDefault();e.stopImmediatePropagation();busy(b,true);Promise.resolve(cartRemoving).then(function(){return syncBundle()}).then(function(){location.assign(root+'checkout')}).catch(function(err){busy(b,false);alert(err.message)});},true);
  function afterAdd(res) {
    if (refCode()) pushRef();
    setTimeout(oneCopyEach, 50);
    if (onCartPage()) { location.reload(); return; }
    var d = drawer();
    if (d && res && res.sections) {
      d.classList.remove('is-empty');
      d.renderContents(res);
      placeExtras(res.sections['cn-drawer-extras']);
      popBadge();
    } else { refreshBubble(); location.href = root + 'cart'; }
  }
  /* ---------- One copy per subject: the bundle counts subjects, so extra copies of the same notes are trimmed to 1 ---------- */
  var trimming = false;
  function oneCopyEach() {
    if (trimming) return; trimming = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var updates = {}, n = 0;
      (c.items || []).forEach(function (it) { if (it.quantity > 1) { updates[it.key] = 1; n++; } });
      if (!n) return;
      var body = { updates: updates };
      if (drawer() && !onCartPage()) { body.sections = SECTIONS; body.sections_url = location.pathname; }
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); }).then(function (res) {
          if (onCartPage()) { location.reload(); return; }
          var d = drawer(); if (d && res && res.sections) { d.renderContents(res); placeExtras(res.sections['cn-drawer-extras']); } else refreshBubble();
        });
    }).catch(function () {}).then(function () { trimming = false; });
  }
  function busy(btn, on) { if (!btn) return; if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); }

  /* ---------- Drawer decorations: bundle block, line prices, digital wording ---------- */
  var extrasTimer, decorating = false;
  function placeExtras(html) {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html || '';
    var block = tmp.querySelector('[data-cn-bs]');
    if (!block) { decorating = true; decorate(d, null); decorating = false; return; }
    decorating = true;
    d.querySelectorAll('[data-cn-bs]').forEach(function (x) { x.remove(); });
    var picks = block.querySelector('.cn-bs__picks');
    var head = d.querySelector('.drawer__header');
    if (head) head.insertAdjacentElement('afterend', block);
    if (picks) { var list = d.querySelector('#CartDrawer-CartItems'); if (list) list.appendChild(picks); }
    decorate(d, block);
    decorating = false;
  }
  function decorate(d, block) {
    var cd = d.querySelector('#CartDrawer'); if (cd) cd.classList.toggle('cn-has-bundle', !!block && block.classList.contains('cn-bs--on'));
    var data = {}; try { data = JSON.parse(block.querySelector('[data-cn-lines]').textContent); } catch (e) {}
    d.querySelectorAll('tr.cart-item').forEach(function (row) {
      var rm = row.querySelector('[data-variant-id]'), price = row.querySelector('.gb-price-drawer');
      var v = rm && data[rm.dataset.variantId];
      if (price && v && v[1] < v[0]) price.innerHTML = '<s>' + money(v[0]) + '</s> <b>' + money(v[1]) + '</b>';
    });
    var sp = d.querySelector('.gb-shipping-protection');
    if (sp) {
      if (!window.shipping_product) sp.style.display = 'none';
      else {
        var h = sp.querySelector('.gb-shipping-protection-icontext h2'), p = sp.querySelector('.gb-shipping-protection-icontext p'), ic = sp.querySelector('.gb-shipping-protection-icon');
        if (h && h.firstChild && h.firstChild.nodeType === 3) h.firstChild.nodeValue = 'Free note updates ';
        if (p) p.textContent = 'If we revise these notes within 12 months, the new edition is emailed to you free.';
        if (ic) ic.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.6M20 5v6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      }
    }
    var g = d.querySelector('.gb-30day-back');
    if (g) { var t = Array.prototype.find.call(g.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); }); if (t) t.nodeValue = ' Instant PDF download after checkout'; }
    var bt = d.querySelector('#CartDrawer-Checkout .button-text'); if (bt) bt.textContent = 'Secure checkout';
    if (cd) cd.classList.add('cn-dec');
  }
  function fetchExtras() {
    clearTimeout(extrasTimer);
    extrasTimer = setTimeout(function () {
      fetch(root + '?sections=cn-drawer-extras').then(function (r) { return r.json(); }).then(function (j) { placeExtras(j['cn-drawer-extras']); }).catch(function () {});
    }, 60);
  }
  function watchDrawer() {
    var d = document.querySelector('cart-drawer'); if (!d || d.__cnWatch) return; d.__cnWatch = true;
    var tpl = document.getElementById('cn-dx-initial'); if (tpl) placeExtras(tpl.innerHTML);
    new MutationObserver(function () {
      if (decorating) return;
      if (!d.querySelector('[data-cn-bs]') || !d.querySelector('#CartDrawer.cn-dec')) fetchExtras();
    }).observe(d, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cn-add]');
    if (!btn) return;
    e.preventDefault();
    busy(btn, true);
    addItems([{ id: Number(btn.dataset.cnAdd), quantity: 1 }])
      .then(function (res) {
        busy(btn, false);
        var l = btn.querySelector('.t-text-swap') || btn.querySelector('span:not([aria-hidden])'), ic = btn.querySelector('.t-icon-swap'), was = btn._was || (l && l.textContent);
        btn._was = was; btn.classList.add('is-added'); if (ic) ic.dataset.state = 'b'; swapText(l, 'Added');
        clearTimeout(btn._rt); btn._rt = setTimeout(function () { btn.classList.remove('is-added'); if (ic) ic.dataset.state = 'a'; swapText(l, was); }, 1800);
        afterAdd(res);
      })
      .catch(function (err) { busy(btn, false); alert(err.message+' Review your cart before retrying.'); });
  });

  /* ---------- Accordions (transitions.dev accordion expand on native <details>) ---------- */
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details.t-acc > summary'); if (!sum) return;
    var d = sum.parentElement; e.preventDefault();
    var dur = DUR('--acc-collapse', 250);
    if (d.open && d.dataset.open === 'true') {
      d.dataset.open = 'false'; sum.setAttribute('aria-expanded', 'false');
      clearTimeout(d._t); d._t = setTimeout(function () { if (d.dataset.open === 'false') d.open = false; }, dur);
    } else {
      clearTimeout(d._t); d.open = true; sum.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { d.dataset.open = 'true'; }); });
    }
  });

  /* Product page form and the mobile sticky bar submit the same form: add without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form.matches || !form.matches('.cn-pdp__form')) return;
    var id = form.querySelector('[name=id]'); if (!id) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[name=add]'); busy(btn, true);
    addItems([{ id: Number(id.value), quantity: 1 }])
      .then(function (res) { busy(btn, false); afterAdd(res); })
      .catch(function (err) { busy(btn, false); alert(err.message+' Review your cart before retrying.'); });
  });

  /* ---------- Bundle box on product page ---------- */
  function initBundle(box) {
    var inputs = box.querySelectorAll('[data-cn-bundle-list] input[type=checkbox]'), btn = box.querySelector('[data-cn-bundle-submit]'), out = box.querySelector('[data-cn-bundle-total]');
    function update() {
      var prices = [];
      inputs.forEach(function (i) { if (i.checked) prices.push(Number(i.dataset.price)); });
      var n = prices.length, total = prices.reduce(function (a, b) { return a + b; }, 0), pct = tierPct(n), final = bundleTotal(prices, pct), pro=box.querySelector('[data-cn-pro]');if(pro&&pro.checked&&!pro.disabled){final+=Number(pro.dataset.price||900);total+=Number(pro.dataset.price||900);}
      if (out) {
        var w = out.querySelector('s'), g = out.querySelector('.t-digit-group');
        if (!g) { out.innerHTML = '<s></s> <span class="t-digit-group"></span>'; w = out.querySelector('s'); g = out.querySelector('.t-digit-group'); g.textContent = money(final); }
        w.textContent = pct ? money(total) : ''; w.hidden = !pct; popDigits(g, money(final));
      }
      if (btn) { var sp = btn.querySelector('span'); if (sp) { if (!sp.classList.contains('t-text-swap')) sp.classList.add('t-text-swap'); swapText(sp, 'Add ' + n + ' to cart'); } btn.disabled = n === 0; }
    }
    function filterRows(){var t=q?q.value.toLowerCase().trim():'',shown=0;box.classList.toggle('is-searching',!!t);box.querySelectorAll('[data-cn-bundle-list] li').forEach(function(li){var input=li.querySelector('input'),hit=t?((li.dataset.q||'').indexOf(t)>-1):input.checked;if(hit&&t&&shown>=8&&!input.checked)hit=false;li.hidden=!hit;if(hit)shown++});if(none)none.hidden=shown>0;}
    function bindInputs(){inputs.forEach(function (i) { if(i._cnBundleBound)return;i._cnBundleBound=true;i.addEventListener('change', function(){if(i.checked&&Array.from(inputs).filter(function(x){return x.checked}).length>4){var selected=Array.from(inputs).filter(function(x){return x.checked&&x!==i});selected[selected.length-1].checked=false;}if(q)q.value='';update();filterRows();}); });}
    bindInputs();
    /* mix and match: search any subject; ticked ones stay visible */
    var q = box.querySelector('[data-cn-bundle-q]'), none = box.querySelector('[data-cn-bundle-none]');
    function ensureOptions(){
      var template=box.querySelector('[data-cn-bundle-options]');if(!template)return;
      var options;try{options=JSON.parse(template.content.textContent);}catch(e){return;}
      var fragment=document.createDocumentFragment();
      options.forEach(function(p){
        var li=document.createElement('li'),label=document.createElement('label'),input=document.createElement('input'),span=document.createElement('span'),strong=document.createElement('strong'),price=document.createElement('em');
        li.dataset.q=((p.code||'')+' '+(p.name||'')).toLowerCase();
        input.type='checkbox';input.value=p.id;input.dataset.price=p.price;label.appendChild(input);
        if(p.image){var image=document.createElement('img');image.src=p.image;image.alt='';image.width=36;image.height=45;image.loading='lazy';label.appendChild(image);}
        strong.textContent=p.code||'';span.appendChild(strong);span.appendChild(document.createTextNode(' '+(p.name||'')));label.appendChild(span);
        price.textContent=money(p.price);label.appendChild(price);li.appendChild(label);fragment.appendChild(li);
      });
      box.querySelector('[data-cn-bundle-list]').appendChild(fragment);template.remove();
      inputs=box.querySelectorAll('[data-cn-bundle-list] input[type=checkbox]');bindInputs();
    }
    if(q)q.addEventListener('input',function(){if(q.value.trim())ensureOptions();filterRows();});
    if (btn) btn.addEventListener('click', function () {
      var items = []; inputs.forEach(function (i) { if (i.checked) items.push({ id: Number(i.value), quantity: 1 }); });
      var pro=box.querySelector('[data-cn-pro]');
      if(pro&&pro.checked&&!pro.disabled){var terms=pro.dataset.price==='2900'?'A$29/month until cancelled':'A$9 first month, then A$29/month until cancelled';if(!confirm('Add CampusNotes Pro? '+terms+'. Notes are charged separately. Cancel anytime in your account.'))return;items.push({id:50679293575424,quantity:1,selling_plan:8356430080,properties:{'Recurring membership consent':terms}});}
      btn.setAttribute('aria-busy', 'true');
      addItems(items).then(function (res) { btn.removeAttribute('aria-busy'); afterAdd(res); }).catch(function (err) { btn.removeAttribute('aria-busy');var error=box.querySelector('[data-cn-pro-error]');if(error){error.hidden=false;error.textContent=err.message+' Review your cart before retrying.'} });
    });
    var proInput=box.querySelector('[data-cn-pro]');if(proInput)proInput.addEventListener('change',update);
    if(proInput&&box.dataset.cnCustomer){proInput.disabled=true;fetch(root+'apps/cn/vip',{headers:{Accept:'application/json'}}).then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(data){proInput.disabled=false;if(data.proIntroEligible===false){proInput.dataset.price='2900';proInput.closest('label').querySelector('b').textContent='$29/month';proInput.closest('label').querySelector('small').textContent='Your introductory offer has been used. $29/month until cancelled. 20% off notes, unlimited re-downloads of owned notes + revision planner.';}if(data.active){proInput.checked=false;proInput.disabled=true;proInput.closest('label').hidden=true;}update();}).catch(function(){proInput.checked=false;proInput.disabled=true;var err=box.querySelector('[data-cn-pro-error]');err.hidden=false;err.textContent='Pro membership could not be checked. You can still buy your notes.';update();});}
    update();filterRows();
  }

  /* ---------- Home bundle builder: four cover slots, tap to add or swap, cross to remove ---------- */
  function initBuilder(el) {
    if (el._bb) return; el._bb = true;
    var data = []; try { data = JSON.parse(el.querySelector('[data-bb-data]').textContent); } catch (e) {}
    var byId = {}; data.forEach(function (d) { byId[d.id] = d; });
    var slots = [].slice.call(el.querySelectorAll('[data-slot]'));
    var state = slots.map(function () { return null; });
    (el.dataset.picked || '').split(',').filter(Boolean).slice(0, 4).forEach(function (id, i) { if (byId[id]) state[i] = byId[id]; });
    var was = el.querySelector('[data-bb-was]'), total = el.querySelector('[data-bb-total]'), hint = el.querySelector('[data-bb-hint]');
    var add = el.querySelector('[data-bb-add]'), label = add.querySelector('.t-text-swap');
    var menu = el.querySelector('[data-bb-menu]'), q = el.querySelector('[data-bb-q]'), results = el.querySelector('[data-bb-results]'), stage = el.querySelector('.cn-bb__stage');
    var p3 = Number(el.dataset.pct3) || 25, p4 = Number(el.dataset.pct4) || 35, active = -1, closeT;
    var X = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8"/></svg>';
    var esc2 = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    function picked() { return state.filter(Boolean); }
    function renderSlot(i) {
      var s = slots[i], it = state[i], btn = s.querySelector('[data-bb-pick]');
      var x = s.querySelector('.cn-bb__x'); if (x) x.remove();
      if (it) {
        var sized = function (w) { return esc2(it.img.replace(/([?&])width=\d+/, '$1width=' + w)); };
        btn.innerHTML = '<img src="' + sized(240) + '" srcset="' + sized(180) + ' 180w, ' + sized(240) + ' 240w, ' + sized(360) + ' 360w" sizes="(max-width:860px) 21vw, 150px" width="360" height="450" loading="lazy" decoding="async" alt="">' + '<span class="cn-bb__swap">Swap</span>';
        btn.setAttribute('aria-label', 'Swap ' + it.code + ' ' + it.name);
        var xb = document.createElement('button'); xb.type = 'button'; xb.className = 'cn-bb__x'; xb.setAttribute('aria-label', 'Remove ' + it.code); xb.innerHTML = X;
        xb.addEventListener('click', function (e) { e.stopPropagation(); state[i] = null; closeMenu(); renderSlot(i); totals(); });
        s.appendChild(xb);
      } else {
        btn.innerHTML = '<span class="cn-bb__empty"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>Add subject</span>';
        btn.setAttribute('aria-label', 'Add a subject');
      }
    }
    function totals(first) {
      var it = picked(), n = it.length, sum = 0, prices = it.map(function (d) { sum += d.price; return d.price; });
      var pc = n >= 4 ? p4 : n >= 3 ? p3 : 0, fin = bundleTotal(prices, pc);
      if (first) total.textContent = money(fin); else popDigits(total, money(fin));
      was.textContent = money(sum); was.hidden = !pc;
      hint.textContent=n<3?'Choose 3 for $64.99 or 4 for $79.99.':n===3?'3 for $64.99. Add a fourth for $79.99.':'4 for $79.99. You save '+money(sum-fin)+'.';
      var t = n ? 'Add ' + n + ' to cart' : 'Add to cart';
      if (first) label.textContent = t; else swapText(label, t);
      add.disabled = n === 0;
    }
    function list(term) {
      var t = (term || '').toLowerCase().trim(), inUse = {};
      picked().forEach(function (d) { inUse[d.id] = true; });
      var hits = data.filter(function (d) { return !inUse[d.id] && (!t || (d.code + ' ' + d.name).toLowerCase().indexOf(t) > -1); }).slice(0, 8);
      results.innerHTML = hits.length ? hits.map(function (d) {
        return '<li><button type="button" role="option" data-id="' + d.id + '">' + (d.thumb ? '<img src="' + d.thumb + '" alt="">' : '<i></i>') + '<span><b>' + esc2(d.code) + '</b><small>' + esc2(d.name) + '</small></span><em>' + money(d.price) + '</em></button></li>';
      }).join('') : '<li class="cn-bb__none">No subject matches that.</li>';
    }
    function openMenu(i) {
      clearTimeout(closeT);
      slots.forEach(function (s, k) { s.querySelector('[data-bb-pick]').setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      active = i; q.value = ''; list('');
      var s = slots[i], sr = s.getBoundingClientRect(), gr = stage.getBoundingClientRect();
      menu.hidden = false;
      var w = menu.offsetWidth, left = Math.min(Math.max(sr.left - gr.left + sr.width / 2 - w / 2, 0), gr.width - w);
      menu.style.left = left + 'px'; menu.style.top = (sr.bottom - gr.top + 10) + 'px';
      menu.style.transformOrigin = (sr.left - gr.left + sr.width / 2 - left) + 'px top';
      requestAnimationFrame(function () { menu.classList.add('is-open'); });
      if (window.matchMedia('(hover:hover)').matches) setTimeout(function () { q.focus({ preventScroll: true }); }, 30);
    }
    function closeMenu() {
      if (menu.hidden) return;
      menu.classList.remove('is-open'); active = -1;
      slots.forEach(function (s) { s.querySelector('[data-bb-pick]').setAttribute('aria-expanded', 'false'); });
      closeT = setTimeout(function () { menu.hidden = true; }, DUR('--duration-quick', 150));
    }
    slots.forEach(function (s, i) { s.querySelector('[data-bb-pick]').addEventListener('click', function (e) { e.stopPropagation(); if (active === i) closeMenu(); else openMenu(i); }); });
    q.addEventListener('input', function () { list(q.value); });
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMenu(); return; }
      if (e.key === 'Enter') { var f = results.querySelector('button'); if (f) { e.preventDefault(); f.click(); } }
      if (e.key === 'ArrowDown') { var b = results.querySelector('button'); if (b) { e.preventDefault(); b.focus(); } }
    });
    results.addEventListener('keydown', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var li = b.parentElement;
      if (e.key === 'ArrowDown' && li.nextElementSibling) { e.preventDefault(); li.nextElementSibling.querySelector('button').focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (li.previousElementSibling) li.previousElementSibling.querySelector('button').focus(); else q.focus(); }
      if (e.key === 'Escape') closeMenu();
    });
    results.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-id]'); if (!b || active < 0) return;
      var i = active; state[i] = byId[b.dataset.id]; closeMenu(); renderSlot(i); totals();
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', closeMenu);
    window.addEventListener('resize', closeMenu);
    add.addEventListener('click', function () {
      var it = picked(); if (!it.length) return;
      add.setAttribute('aria-busy', 'true');
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }).then(function (cart) {
        var have = {}; (cart.items || []).forEach(function (c) { have[c.variant_id] = true; });
        var items = it.filter(function (d) { return !have[d.id]; }).map(function (d) { return { id: d.id, quantity: 1 }; });
        if (!items.length) { add.removeAttribute('aria-busy'); location.href = root + 'cart'; return; }
        return addItems(items).then(function (res) { add.removeAttribute('aria-busy'); swapText(label, 'Added'); setTimeout(function () { totals(); }, 1600); afterAdd(res); });
      }).catch(function () { add.removeAttribute('aria-busy'); location.href = root + 'cart'; });
    });
    slots.forEach(function (s, i) { renderSlot(i); });
    totals(true);
  }

  /* ---------- Tabs sliding (seller dashboard) ---------- */
  function initTabs(bar) {
    if (bar._tabs) return; bar._tabs = true;
    var pill = document.createElement('span'); pill.className = 't-tabs-pill'; pill.setAttribute('aria-hidden', 'true'); bar.insertBefore(pill, bar.firstChild);
    var tabs = [].slice.call(bar.querySelectorAll('[role=tab]'));
    function active() { return tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0]; }
    function moveTo(tab, animate) {
      if (!tab) return;
      if (!animate) { var prev = pill.style.transition; pill.style.transition = 'none'; pill.style.transform = 'translateX(' + tab.offsetLeft + 'px)'; pill.style.width = tab.offsetWidth + 'px'; void pill.offsetWidth; pill.style.transition = prev; }
      else { pill.style.transform = 'translateX(' + tab.offsetLeft + 'px)'; pill.style.width = tab.offsetWidth + 'px'; }
    }
    bar.addEventListener('click', function (e) { var t = e.target.closest('[role=tab]'); if (t) requestAnimationFrame(function () { moveTo(t, true); }); });
    requestAnimationFrame(function () { moveTo(active(), false); });
    window.addEventListener('resize', function () { moveTo(active(), false); });
  }

  /* ---------- Card cover: hover and move across to flick through the preview pages ---------- */
  /* Warm the preview pages before the pointer arrives: first pages when a card scrolls into view, the rest on idle. */
  var warmed = typeof WeakSet === 'function' ? new WeakSet() : null;
  function warm(a, n) {
    var urls; try { urls = JSON.parse(a.dataset.pages || '[]'); } catch (x) { return; }
    urls.slice(0, n).forEach(function (u) { var i = new Image(); i.decoding = 'async'; i.src = u; });
  }
  function initWarm() {
    if (!window.matchMedia('(hover:hover)').matches || !('IntersectionObserver' in window) || !warmed) return;
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || warmed.has(e.target)) return;
        warmed.add(e.target); io.unobserve(e.target);
        idle(function () { warm(e.target, 2); idle(function () { warm(e.target, 8); }); });
      });
    }, { rootMargin: '200px' });
    document.querySelectorAll('.cn-scrub').forEach(function (a) { io.observe(a); });
  }
  function initScrub() {
    if (!window.matchMedia('(hover:hover)').matches) return;
    document.addEventListener('pointerenter', function (e) { var a = e.target.closest && e.target.closest('.cn-scrub'); if (a && !a._warm) { a._warm = true; warm(a, 8); } }, true);
    document.addEventListener('pointerover', function (e) {
      var a = e.target.closest && e.target.closest('.cn-scrub'); if (!a || a._scrub) return;
      var urls; try { urls = JSON.parse(a.dataset.pages || '[]'); } catch (x) { return; }
      if (!urls.length) return;
      var page = a.querySelector('.cn-scrub__page'), bars = a.querySelectorAll('.cn-scrub__bars i'), cur = -1;
      var img = document.createElement('img'); img.alt = ''; img.decoding = 'async'; page.appendChild(img);
      urls.forEach(function (u) { var i = new Image(); i.src = u; });
      function show(i) {
        if (i === cur) return; cur = i; img.src = urls[i];
        for (var k = 0; k < bars.length; k++) bars[k].classList.toggle('on', k === i);
      }
      a.addEventListener('pointermove', function (ev) {
        var r = a.getBoundingClientRect(), x = Math.min(Math.max(ev.clientX - r.left, 0), r.width - 1);
        show(Math.floor(x / r.width * urls.length)); a.classList.add('is-on');
      });
      a.addEventListener('pointerleave', function () { a.classList.remove('is-on'); cur = -1; for (var k = 0; k < bars.length; k++) bars[k].classList.remove('on'); });
      a._scrub = true;
    });
  }
  initScrub();

  /* ---------- Shelves ---------- */
  function initShelf(s) {
    var track = s.querySelector('.cn-shelf__track'), prev = s.querySelector('[data-dir=prev]'), next = s.querySelector('[data-dir=next]');
    if (!track || !prev || !next) return;
    function state() { prev.disabled = track.scrollLeft < 4; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * .9, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * .9, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
    state();
  }

  /* ---------- Search: forgiving, typo-tolerant, works from 2 letters ---------- */
  var SYN = {
    macro: 'macroeconomics', macros: 'macroeconomics', micro: 'microeconomics', eco: 'economics', econs: 'economics', economic: 'economics',
    qm: 'quantitative methods', qm1: 'quantitative methods 1', quant: 'quantitative', quants: 'quantitative', stats: 'quantitative statistics', stat: 'quantitative statistics', statistics: 'quantitative', maths: 'quantitative', math: 'quantitative',
    acc: 'accounting', accy: 'accounting', accounts: 'accounting', fin: 'finance', fins: 'finance', mktg: 'marketing', mkt: 'marketing', mgmt: 'management', mgt: 'management',
    ob: 'organisational behaviour', org: 'organisational', organizational: 'organisational', behavior: 'behaviour', analytics: 'business analytics', ba: 'business analytics', fba: 'foundations business analytics',
    actuarial: 'actuarial', act: 'actuarial', cities: 'cities planning', urban: 'urban planning cities', planning: 'planning cities', intro: 'introductory introduction', first: 'level 1', second: 'level 2', commerce: 'bcom'
  };
  var idx = null, idxP = null;
  function norm(t) { return String(t || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function loadIndex() {
    if (idx) return Promise.resolve(idx);
    if (idxP) return idxP;
    try { var c = JSON.parse(sessionStorage.getItem('cn-idx') || 'null'); if (c && Date.now() - c.t < 36e5) { idx = c.d; return Promise.resolve(idx); } } catch (e) {}
    var all = [];
    function page(n) {
      return fetch(root + 'collections/study-notes/products.json?limit=250&page=' + n).then(function (r) { return r.json(); }).then(function (j) {
        var ps = j.products || []; all = all.concat(ps);
        return ps.length === 250 && n < 8 ? page(n + 1) : all;
      });
    }
    idxP = page(1).then(function (ps) {
      idx = ps.map(function (p) {
        var t = p.title.replace(/ Study Notes$/i, ''), m = t.match(/^([A-Z]{4})(\d{4,5})\s+(.*)$/);
        var code = m ? m[1] + m[2] : '', name = m ? m[3] : t;
        var tags = (p.tags || []).join(' ');
        var words = norm(name + ' ' + tags + ' ' + p.product_type).split(' ').filter(Boolean);
        return { code: code, alpha: m ? m[1].toLowerCase() : '', num: m ? m[2] : '', name: name, words: words, url: root + 'products/' + p.handle,
          price: p.variants && p.variants[0] ? p.variants[0].price : '', img: p.images && p.images[0] ? p.images[0].src : '' };
      });
      try { sessionStorage.setItem('cn-idx', JSON.stringify({ t: Date.now(), d: idx })); } catch (e) {}
      return idx;
    }).catch(function () { idxP = null; return []; });
    return idxP;
  }
  function dist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      var best = 99;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        if (d[i][j] < best) best = d[i][j];
      }
      if (best > max) return max + 1;
    }
    return d[a.length][b.length];
  }
  function tokScore(t, p) {
    var best = 0, code = p.code.toLowerCase();
    if (code === t) return 20;
    if (code && code.indexOf(t) === 0) best = 14;
    if (p.num && p.num.indexOf(t) === 0 && t.length >= 2) best = Math.max(best, 13);
    if (p.alpha && t.length >= 2 && p.alpha.indexOf(t) === 0) best = Math.max(best, 11);
    var allow = t.length >= 7 ? 2 : t.length >= 4 ? 1 : 0;
    for (var i = 0; i < p.words.length; i++) {
      var w = p.words[i];
      if (w === t) best = Math.max(best, 10);
      else if (w.indexOf(t) === 0) best = Math.max(best, 8);
      else if (t.length >= 3 && w.indexOf(t) > 0) best = Math.max(best, 4);
      else if (allow && w.length >= 3) {
        var dd = Math.min(dist(t, w, allow), dist(t, w.slice(0, t.length), allow));
        if (dd <= allow) best = Math.max(best, 6 - dd * 2);
      }
    }
    if (allow && code) { var dc = dist(t, code.slice(0, t.length), allow); if (dc <= allow) best = Math.max(best, 7 - dc * 2); }
    return best;
  }
  function searchIdx(q, list) {
    var STOP = { year: 1, yr: 1, notes: 1, note: 1, study: 1, subject: 1, uni: 1, unimelb: 1, melbourne: 1, the: 1, of: 1, and: 1, for: 1, sem: 1, semester: 1, summary: 1, summaries: 1 };
    var raw = norm(q).replace(/([a-z])(\d)/g, '$1 $2').split(' ').filter(function (t) { return t && !STOP[t]; });
    var joined = norm(q).replace(/\s+/g, '');
    if (!raw.length) return [];
    return list.map(function (p) {
      var code = p.code.toLowerCase();
      if (joined.length >= 4 && code.indexOf(joined) === 0) return { p: p, s: 30 };
      var total = 0;
      for (var i = 0; i < raw.length; i++) {
        var t = raw[i], sc = tokScore(t, p);
        if (SYN[t]) SYN[t].split(' ').forEach(function (x) { var v = tokScore(x, p); if (v >= 8) sc = Math.max(sc, v - 1); });
        if (!sc) return null;
        total += sc;
      }
      return { p: p, s: total };
    }).filter(Boolean).sort(function (a, b) { return b.s - a.s || (a.p.code > b.p.code ? 1 : -1); }).map(function (r) { return r.p; });
  }
  function initSearch(form) {
    var input = form.querySelector('input[type=search]'), box = form.querySelector('.cn-sugg');
    if (!input || !box) return;
    var timer, active = -1, last = [];
    function close() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; input.removeAttribute('aria-activedescendant'); }
    function items() { return box.querySelectorAll('a[role=option]'); }
    function highlight(i) {
      var list = items(); if (!list.length) return;
      active = (i + list.length) % list.length;
      list.forEach(function (a, n) { a.setAttribute('aria-selected', n === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', list[active].id);
    }
    function render(q, res) {
      last = res;
      if (!res.length) box.innerHTML = '<div class="cn-sugg__none">Nothing for "' + esc(q) + '" yet. Try your subject code, like ECON10003, or a word like "macro".</div>';
      else box.innerHTML = res.slice(0, 6).map(function (p, i) {
        var img = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=80' : '';
        return '<a role="option" id="' + box.id + '-o' + i + '" aria-selected="false" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="36" height="45" loading="lazy">' : '<span></span>') +
          '<div><strong>' + esc(p.code || p.name) + '</strong><span>' + esc(p.code ? p.name : '') + '</span></div><em>' + (p.price ? '$' + Number(p.price).toFixed(2) : '') + '</em></a>';
      }).join('') + (res.length > 6 ? '<a class="cn-sugg__all" href="#" data-cn-all>See all ' + res.length + ' matches</a>' : '');
      box.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1;
    }
    function run() {
      var q = input.value.trim(); if (q.length < 2) { close(); return; }
      loadIndex().then(function (list) { if (input.value.trim() === q) render(q, searchIdx(q, list)); });
    }
    function go(q) {
      loadIndex().then(function (list) {
        var res = searchIdx(q, list);
        if (res.length === 1) { location.href = res[0].url; return; }
        var codes = res.slice(0, 40).map(function (p) { return p.code; }).filter(Boolean);
        var terms = codes.length ? codes.join(' OR ') : q;
        location.href = form.action + '?type=product&q=' + encodeURIComponent(terms) + '&cn=' + encodeURIComponent(q);
      });
    }
    input.addEventListener('focus', loadIndex, { once: true });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 90); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
      else if (e.key === 'Escape') close();
    });
    box.addEventListener('click', function (e) { if (e.target.closest('[data-cn-all]')) { e.preventDefault(); go(input.value.trim()); } });
    form.addEventListener('submit', function (e) { var q = input.value.trim(); if (!q) return; e.preventDefault(); go(q); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    var cn = new URLSearchParams(location.search).get('cn');
    if (cn && input.value.indexOf(' OR ') > -1) input.value = cn;
  }
  (function fixSearchHeading() {
    var cn = new URLSearchParams(location.search).get('cn'); if (!cn) return;
    document.addEventListener('DOMContentLoaded', function () {
      var h = document.querySelector('.cn-lib__h'); if (h) h.textContent = 'Results for “' + cn + '”';
      var e = document.querySelector('.cn-empty__h'); if (e) e.textContent = 'No notes for “' + cn + '” yet';
      document.title = 'Results for ' + cn + ' | CampusNotes';
    });
  })();
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || /input|textarea|select/i.test(document.activeElement.tagName)) return;
    var i = document.querySelector('[data-cn-search] input[type=search]'); if (i) { e.preventDefault(); i.focus(); }
  });

  /* ---------- Client filters ---------- */
  function initFilter(el) {
    var cards = Array.prototype.slice.call(el.querySelectorAll('.cn-card')), count = el.querySelector('[data-cn-count]'), empty = el.querySelector('[data-cn-empty]'), text = el.querySelector('[data-cn-text]');
    var state = { disc: '', level: '', q: '' };
    function apply() {
      var shown = 0, q = state.q.toLowerCase().trim();
      cards.forEach(function (c) { var ok = (!state.disc || c.dataset.disc === state.disc) && (!state.level || c.dataset.level === state.level) && (!q || c.dataset.q.indexOf(q) > -1); c.hidden = !ok; if (ok) shown++; });
      if (count) count.textContent = shown + (shown === 1 ? ' subject' : ' subjects');
      if (empty) empty.hidden = shown !== 0;
    }
    el.querySelectorAll('[data-cn-group]').forEach(function (g) {
      var key = g.dataset.cnGroup;
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]'); if (!b) return; e.preventDefault();
        state[key] = b.dataset.value;
        g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    if (text) text.addEventListener('input', function () { state.q = text.value; apply(); });
  }

  /* ---------- Referral capture: ?ref=CODE is saved to the cart so the order credits the referrer ---------- */
  function refCode() { try { var r = JSON.parse(localStorage.getItem('cn-ref') || 'null'); return r && Date.now() - r.t < 30 * 864e5 ? r.c : ''; } catch (e) { return ''; } }
  function pushRef() { var c = refCode(); if (!c) return; fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ref: c } }) }).catch(function () {}); }
  (function () {
    var q = new URLSearchParams(location.search).get('ref');
    if (q && /^[A-Za-z0-9][A-Za-z0-9-]{3,19}$/.test(q)) {
      var code = q.toUpperCase();
      try { localStorage.setItem('cn-ref', JSON.stringify({ c: code, t: Date.now() })); } catch (e) {}
      pushRef();
      /* The referral code doubles as the friend's discount code: apply it to this session so checkout picks it up. */
      fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
        .catch(function () {});
    }
  })();

  var coverQueue = new Set(), coverFrame = 0, coverColours = new Map();
  var coverElements = new WeakMap();
  var coverResize = window.ResizeObserver ? new ResizeObserver(function(entries) {
    entries.forEach(function(entry) { queueCover(coverElements.get(entry.target)); });
  }) : null;
  function queueCover(el) {
    if (!el) return;
    coverQueue.add(el);
    if (!coverFrame) coverFrame = requestAnimationFrame(placeCovers);
  }
  function placeCovers() {
    coverFrame = 0;
    var positions = [];
    coverQueue.forEach(function(el) {
      var img = el.querySelector('img'), count = el.querySelector('.cn-cover-count');
      if (!img || !count) return;
      var r = img.getBoundingClientRect(), p = el.getBoundingClientRect();
      if (r.width > 0) positions.push({count:count, r:r, p:p});
    });
    coverQueue.clear();
    positions.forEach(function(item) {
      var r=item.r, p=item.p, style=item.count.style;
      style.left=(r.left-p.left+r.width*.61)+'px';
      style.top=(r.top-p.top+r.height*.887)+'px';
      style.width=(r.width*.31)+'px';
      style.height=(r.height*.075)+'px';
      style.fontSize=(r.width*.0367)+'px';
    });
  }
  function colourCover(el, img) {
    if (el._colour || !img.complete || !img.naturalWidth) return;
    el._colour = true;
    var idle = window.requestIdleCallback || function(fn) { return setTimeout(fn, 100); };
    idle(function() {
      try {
        var key=img.currentSrc||img.src, colour=coverColours.get(key);
        if (!colour) {
          var canvas=document.createElement('canvas'); canvas.width=1; canvas.height=1;
          var ctx=canvas.getContext('2d',{willReadFrequently:true});
          ctx.drawImage(img,img.naturalWidth*.1,img.naturalHeight*.1,1,1,0,0,1,1);
          var rgb=ctx.getImageData(0,0,1,1).data;
          colour='rgb('+rgb[0]+','+rgb[1]+','+rgb[2]+')'; coverColours.set(key,colour);
        }
        var scope=el.closest('.cn-card')||el.closest('.cn-pdp');
        if (scope) {
          var targets=[scope], info=scope.querySelector('.cn-pdp__info');
          if (info) targets.push(info);
          targets.forEach(function(target) {
            target.style.setProperty('--d',colour);
            target.style.setProperty('--dt','color-mix(in srgb,'+colour+' 9%,white)');
          });
        }
      } catch (e) { /* The server-rendered discipline colour remains available. */ }
    });
  }
  function activateCover(el) {
    var img=el.querySelector('img');
    if (!img || el._count) return;
    el._count=true;
    var count=document.createElement('span'); count.className='cn-cover-count';
    count.setAttribute('aria-hidden','true'); count.textContent=el.dataset.cnCoverPages+' pages';
    el.appendChild(count); coverElements.set(img,el);
    function update() { queueCover(el); colourCover(el,img); }
    img.addEventListener('load',update);
    if (coverResize) coverResize.observe(img);
    update();
  }
  var coverVisibility = window.IntersectionObserver ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) { activateCover(entry.target); coverVisibility.unobserve(entry.target); }
    });
  }, {rootMargin:'150px'}) : null;
  function coverCounts() {
    document.querySelectorAll('[data-cn-cover-pages]').forEach(function(el) {
      if (el._count || el._coverQueued || !el.dataset.cnCoverPages || !el.querySelector('img')) return;
      el._coverQueued=true;
      if (coverVisibility) coverVisibility.observe(el); else activateCover(el);
    });
    if (!coverResize) window.addEventListener('resize',function() {
      document.querySelectorAll('[data-cn-cover-pages]').forEach(function(el) { if(el._count)queueCover(el); });
    });
  }
  function init() {coverCounts();if(onCartPage())syncBundle().then(function(res){if(res._cnChanged)location.reload()}).catch(function(){});


    oneCopyEach();
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('cart-drawer, cart-items, quantity-input')) setTimeout(function(){oneCopyEach();syncBundle().then(function(res){var d=drawer();if(d&&res.sections){d.renderContents(res);placeExtras(res.sections['cn-drawer-extras'])}}).catch(function(){})}, 600); });
    document.querySelectorAll('[data-cn-search]').forEach(initSearch);
    document.querySelectorAll('[data-cn-filter]').forEach(initFilter);
    document.querySelectorAll('[data-cn-shelf]').forEach(initShelf);
    document.querySelectorAll('[data-cn-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-cn-bb]').forEach(initBuilder);
    document.querySelectorAll('.t-tabs').forEach(initTabs);
    initWarm();
    watchDrawer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

